import React, {CSSProperties} from 'react';
import classNames from 'classnames';

export type FieldDecoratorProps = {
	label?: string | React.ReactNode;
	error?: string;
	info?: string | React.ReactNode;
	className?: string;
	disabled?: boolean;
	required?: boolean;
	size?: 'small' | 'medium-width' | 'full-width';
	onLabelClick?: () => void;
	style?: CSSProperties;
};

type Props = FieldDecoratorProps;

export default function FieldDecorator({
	children,
	label,
	error,
	info,
	className,
	disabled,
	required,
	size,
	onLabelClick,
	style
}: React.PropsWithChildren<Props>) {
	return (
		<div
			style={style}
			className={classNames(className, 'di field', size, {
				error,
				'input-disabled': disabled,
				'label-clickable': onLabelClick && !disabled
			})}>
			{label && (
				<label onClick={onLabelClick}>
					{' '}
					{label} {required && '*'}{' '}
				</label>
			)}
			{children}
			{error && <span className="error-msg">{error}</span>}
			{info && <span className="info-msg">{info}</span>}
		</div>
	);
}
